import { render, staticRenderFns } from "./BusClsClmNol1.vue?vue&type=template&id=51d61bcd&"
import script from "./BusClsClmNol1.vue?vue&type=script&lang=js&"
export * from "./BusClsClmNol1.vue?vue&type=script&lang=js&"
import style0 from "./BusClsClmNol1.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "BusClsClmNol1.vue"
export default component.exports